import { z } from "zod";
export const sessionUserSchema = z.object({
    id: z.string(),
    email: z.string().nullable(),
    displayName: z.string().nullable(),
    isSuperadmin: z.boolean(),
    hasPasscode: z.boolean(),
});
export const companyMembershipSchema = z.object({
    companyId: z.string(),
    slug: z.string(),
    name: z.string(),
    currencyCode: z.string(),
    timezone: z.string(),
    taxPriceMode: z.enum(["inclusive", "exclusive"]),
    discountSoftCapPct: z.number(),
    /** Seeded role codes for this membership (e.g. cashier, manager). */
    roleCodes: z.array(z.string()).default([]),
    /** Flattened action / override permission keys — plan/15. */
    permissions: z.array(z.string()).default([]),
});
export const authMeSchema = z.object({
    user: sessionUserSchema,
    companies: z.array(companyMembershipSchema),
});
